import { ChoiceCard, Radio, Typography } from '@eventbrite/marmalade';
import styles from './RadioListQuestion.module.scss';
import { useState } from 'react';

export interface RadioOption {
    value: number;
    name: string;
    text: string;
    description?: string;
    icon?: React.ReactNode;
}

export interface SelectedOption {
    value: number;
    name: string;
    text: string;
}

interface RadioListQuestionProps {
    options: RadioOption[];
    name: string;
    onChangeValue?: (value: SelectedOption) => void;
    initialValue?: number;
}

export const RadioListQuestion: React.FC<RadioListQuestionProps> = ({
    options,
    name,
    onChangeValue,
    initialValue,
}) => {
    const [value, setValue] = useState<number | undefined>(initialValue);

    const onChange = (index: number) => {
        const { value, name, text } = options[index];
        setValue(value);
        onChangeValue && onChangeValue({ value, name, text });
    };

    return (
        <div className={styles.grid} data-testid={`radio-card-sales`}>
            {options.map((option, index) => (
                <label htmlFor={`${name}-${option.value}`} key={index}>
                    <ChoiceCard
                        className={styles.card}
                        aria-checked={options[index].value === value}
                        data-testid={`option-item-${index}`}
                    >
                        <div className={styles.input} data-testid="radio-input">
                            <Radio
                                name={`${name}`}
                                checked={options[index].value === value}
                                onChange={() => onChange(index)}
                                id={`${name}-${option.value}`}
                                data-testid={`${name}-${option.value}`}
                            />
                        </div>
                        {option.icon && <div className="icon">{option.icon}</div>}
                        <div>
                            <Typography
                                as="p"
                                data-testid="subheading"
                                align="center"
                                variant="body-md-bold"
                                color="neutral-900"
                            >
                                {option.text}
                            </Typography>
                            {option.description && (
                                <div>
                                    <Typography
                                        as="p"
                                        data-testid="subheading"
                                        align="center"
                                        variant="body-md"
                                        color="neutral-900"
                                    >
                                        {option.description}
                                    </Typography>
                                </div>
                            )}
                        </div>
                    </ChoiceCard>
                </label>
            ))}
        </div>
    );
};
